import React from 'react';
import { CellProps } from 'react-table';
import { ApplicationsTableRow } from '../common/types/types';
import { ApplicationUnitNumberCell } from '../common/types/applications-table-row';

export const OffersUnitNumberCell = ({ value }: CellProps<ApplicationsTableRow, ApplicationUnitNumberCell>) => {
  const { unitNumber } = value;
  return <span>{unitNumber}</span>;
};
